import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { parseMarkdownContent } from '../../../../utils/parseMarkdownContent';

interface ServiceContentProps {
  content: string;
}

export default function ServiceContent({ content }: ServiceContentProps) {
  const { t } = useTranslation();
  const html = parseMarkdownContent(content);
  const headings = content.split('\n').filter((line) => line.startsWith('## '));

  return (
    <section className="bg-white py-16">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-12">
          <article>
            <div className="prose-web3" dangerouslySetInnerHTML={{ __html: html }} />
          </article>

          <aside className="space-y-6">
            {headings.length > 0 && (
              <div className="bg-light-alt border border-primary/10 rounded-xl p-5 sticky top-24">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-list-check-2 text-primary text-sm" />
                  </div>
                  <span className="text-sm font-medium text-gray-800">{t('serviceDetail.outline')}</span>
                </div>
                <div className="space-y-2">
                  {headings.map((line, i) => (
                    <div
                      key={i}
                      className="flex items-start gap-2 text-gray-500 text-sm py-1.5 px-2 rounded-lg"
                    >
                      <span className="text-primary font-mono text-xs mt-0.5 shrink-0">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <span className="line-clamp-2">{line.replace('## ', '')}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="bg-light-alt border border-primary/10 rounded-xl p-5">
              <p className="text-gray-400 text-xs mb-3">{t('serviceDetail.contactHint')}</p>
              <Link
                to="/contact"
                className="flex items-center justify-center gap-2 w-full py-2.5 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary-dark transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-line text-sm" />
                </div>
                {t('serviceDetail.contactTeam')}
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
